<span [class]="classes">{{ label | humancase }}</span>
